module.exports = __webpack_public_path__ + "1b34a343a7c421368fa2cd05103353a8.png";